export const personaIds = {
  softwareDevelopmentIt: 'software_development_it',
  productDesignResearch: 'product_design_research',
  dataAnalytics: 'data_analytics',
  businessOperations: 'business_operations',
  learningTeaching: 'learning_teaching',
  other: 'other',
} as const

export const personas = [
  {id: personaIds.softwareDevelopmentIt, label: 'Software development and IT'},
  {id: personaIds.productDesignResearch, label: 'Product, design, and research'},
  {id: personaIds.dataAnalytics, label: 'Data and analytics'},
  {id: personaIds.businessOperations, label: 'Business and operations'},
  {id: personaIds.learningTeaching, label: 'Learning and teaching'},
  {id: personaIds.other, label: 'Other'},
] as const

export type CopilotPersona = (typeof personas)[number]['id']

export interface PersonaOnboardingPayload {
  enabled: boolean
  show: boolean
  persona: CopilotPersona | null
  savePath: string
  suggestedTasksDismissed?: boolean
}

export type PersonaOnboardingUpdate =
  | {status: 'completed'; persona: CopilotPersona}
  | {status: 'dismissed' | 'suggested_tasks_dismissed'}
